<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vs-button class="float-left" icon="icon-plus" @click.stop="onClickChartCreate"
                   color="primary" type="filled" icon-pack="feather">Add chart
        </vs-button>
        <vs-button class="float-right ml-1 mr-4 btn-sm" icon="icon-chevron-up" @click.stop="collapseAllCharts"
                   color="primary" type="border" size="small" icon-pack="feather">Collapse All
        </vs-button>
        <vs-button class="float-right ml-1 mr-4 btn-sm" icon="icon-chevron-down" @click.stop="expandAllCharts"
                   color="primary" type="border" size="small" icon-pack="feather">Expand All
        </vs-button>
      </div>
    </div>
<!--    <draggable :list="charts" class="cursor-move">-->
      <div class="vx-row" v-for="(chart, index_chart) in charts" :key="index_chart">
        <div class="vx-col w-full">
          <chart-component :report_data="chart" :index_chart="index_chart" ref="chartComponents" />
        </div>
      </div>
<!--    </draggable>-->
    <chart-create-side-bar ref="chartCreateSideBar"/>
  </div>
</template>

<script>
import SalesRevenue from './fixed-charts/SalesRevenue'
import ChartComponent from './fixed-charts/ChartComponent'
import VueDragResize from 'vue-drag-resize'
import ChartCreateSideBar from "@/components/sidebars/ChartCreateSideBar";


import { RepositoryFactory } from "@/repository/RepositoryFactory";
import ErrorMessages from "@/mixins/ErrorMessages";
import SuccessMessage from "@/mixins/SuccessMessage";
import {mapActions} from "vuex";
const ReportingRepository = RepositoryFactory.get('reporting');
import draggable from 'vuedraggable'
export default {
  name: "ChartHome",
  data() {
    return {
      charts: [],
    }
  },
  components: {
    SalesRevenue,
    ChartComponent,
    ChartCreateSideBar,
    'vue-drag-resize': VueDragResize,
    draggable,
  },
  mixins: [ ErrorMessages, SuccessMessage ],
  methods: {
    ...mapActions({
      fetchCustomers: 'fetchCustomers',
      fetchCountries: 'fetchCountries',
      fetchSuppliers: 'fetchSuppliers',
      fetchSundrySuppliers: 'fetchSundrySuppliers',
      fetchStaffs: 'fetchStaffs',
      fetchFormulations: 'fetchFormulations',
      fetchIndustrySections: 'fetchIndustrySections',
      fetchRawMaterial: 'fetchRawMaterial'
    }),
    resize(newRect) {

    },
    onClickChartCreate() {
      this.$refs.chartCreateSideBar.openSideBar()
    },
    collapseAllCharts() {
      if (this.$refs.chartComponents) {
        this.$refs.chartComponents.forEach(chart => {
          if (chart && typeof chart.collapse === "function") {
            chart.collapse();
          }
        });
      }
    },
    expandAllCharts() {
      if (this.$refs.chartComponents) {
        this.$refs.chartComponents.forEach(chart => {
          if (chart && typeof chart.expand === "function") {
            chart.expand();
          }
        });
      }
    },
    async fetchReports() {
      try {
        const { data } = (await ReportingRepository.getAllCharts()).data
        this.charts = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
  },
  async mounted() {
    Promise.all([
      this.fetchStaffs(),
      this.fetchFormulations(),
      this.fetchCountries(),
      this.fetchCustomers(),
      this.fetchSuppliers(),
      this.fetchSundrySuppliers(),
      this.fetchIndustrySections(),
      this.fetchRawMaterial()
    ]).catch(e => console.error(e))

    await this.fetchReports()
  }

}
</script>

<style scoped>

</style>
